import { Routes } from '@angular/router';
import { ADS_MANAGEMENT_ROUTE, ALERT_ROUTE, BANK_MANAGEMENT_ROUTE, CONTRACT_MANAGEMENT_ROUTE, CONTROVERSY_CENTER_ROUTE, CUSTOMER_COMPANY_ROUTE, EMPLOYEE_ROUTE, GOLD_ADS_MANAGEMENT_ROUTE, HOME_ROUTE, INVITE_COLLABORATORS_ROUTE, USER_MANAGEMENT_ROUTE, WEB_MANAGEMENT_ROUTE, WHISTLEBLOWING_ROUTE } from '../constants/constants';

export const content: Routes = [
  {
    path: '',
    redirectTo: HOME_ROUTE,
    pathMatch: 'full'
  },
  {
    path: CUSTOMER_COMPANY_ROUTE,
    data: {
      title: 'pagetitle.company_management',
      breadcrumb: 'pagetitle.company_management'
    },
    loadChildren: () => import('../../components/customer-company-management/customer-company-management.routes')
  },
  {
    path: EMPLOYEE_ROUTE,
    data: {
      title: 'pagetitle.employee_management',
      breadcrumb: 'pagetitle.employee_management'
    },
    loadChildren: () => import('../../components/employee-management/employee-management.routes')
  },
  {
    path: ADS_MANAGEMENT_ROUTE,
    data: {
      title: 'pagetitle.ads_management',
      breadcrumb: 'pagetitle.ads_management'
    },
    loadChildren: () => import('../../components/ad-management/ad-management.routes')
  },
  {
    path: GOLD_ADS_MANAGEMENT_ROUTE,
    data: {
      title: 'pagetitle.gold_ads_management',
      breadcrumb: 'pagetitle.gold_ads_management'
    },
    loadChildren: () => import('../../components/gold-ad-management/gold-ad-management.routes')
  },
  {
    path: CONTRACT_MANAGEMENT_ROUTE,
    data: {
      title: 'pagetitle.contract_management',
      breadcrumb: 'pagetitle.contract_management'
    },
    loadChildren: () => import('../../components/contract-management/contract-management.routes')
  },
  {
    path: BANK_MANAGEMENT_ROUTE,
    data: {
      title: 'pagetitle.bank_management',
      breadcrumb: 'pagetitle.bank_management'
    },
    loadChildren: () => import('../../components/bank-management/bank-management.routes')
  },
  {
    path: CONTROVERSY_CENTER_ROUTE,
    data: {
      title: 'pagetitle.controversy_center',
      breadcrumb: 'pagetitle.controversy_center'
    },
    loadChildren: () => import('../../components/controversy-management/controversy-management.routes')
  },
  {
    path: ALERT_ROUTE,
    data: {
      title: 'pagetitle.alerts',
      breadcrumb: 'pagetitle.alerts'
    },
    loadChildren: () => import('../../components/alert-system/alert-system.routes')
  },
  {
    path: WHISTLEBLOWING_ROUTE,
    data: {
      title: 'pagetitle.whistleblowing',
      breadcrumb: 'pagetitle.whistleblowing'
    },
    loadChildren: () => import('../../components/whistleblowing/whistleblowing.routes')
  },
  {
    path: INVITE_COLLABORATORS_ROUTE,
    data: {
      title: 'pagetitle.collaborators_invitation',
      breadcrumb: 'pagetitle.collaborators_invitation'
    },
    loadChildren: () => import('../../components/invite-collaborators/invite-collaborators.routes')
  },
  {
    path: USER_MANAGEMENT_ROUTE,
    data: {
      title: 'pagetitle.user_management',
      breadcrumb: 'pagetitle.user_management'
    },
    loadChildren: () => import('../../components/user-management/user-management.routes')
  },
  {
    path: WEB_MANAGEMENT_ROUTE,
    data: {
      title: 'pagetitle.web_management',
      breadcrumb: 'pagetitle.web_management'
    },
    loadChildren: () => import('../../components/web-management/web-management.routes')
  },
  {
    path: 'profile',
    data: {
      title: 'my_profile.title',
      breadcrumb: 'pagetitle.profile'
    },
    loadComponent: () =>
      import('../../components/settings/my-profiles/my-profile.component').then(
        (m) => m.MyProfileComponent
      )
  }
];
